import { action, observable, makeObservable } from 'mobx';

import { OfficeData, OfficeStatus, OfficeUpdateForm } from 'chaika-frontend-types/frontend-cms';

export class Office {
    @observable public readonly id: string;
    @observable public readonly organizationId: string;
    @observable public name: string;
    @observable public typeId: string;
    @observable public specialtyIds?: string[];
    @observable public status: OfficeStatus;
    @observable public creationTime: string;
    @observable public floor?: string;
    @observable public proposedSpecialtyIds?: string[];

    constructor(
        {
            id,
            name,
            organizationId,
            typeId,
            specialtyIds,
            status,
            creationTime,
            floor,
            proposedSpecialtyIds,
        }: OfficeData = {} as OfficeData,
    ) {
        makeObservable(this);

        this.id = id;
        this.name = name;
        this.organizationId = organizationId;
        this.typeId = typeId;
        this.status = status;
        this.floor = floor;
        this.specialtyIds = specialtyIds;
        this.creationTime = creationTime;
        this.proposedSpecialtyIds = proposedSpecialtyIds;
    }

    @action
    public update(params: OfficeUpdateForm): void {
        const {
            name = this.name,
            specialtyIds = this.specialtyIds,
            typeId = this.typeId,
            floor = this.floor,
            proposedSpecialtyIds = this.proposedSpecialtyIds,
        } = params;

        this.name = name;
        this.specialtyIds = specialtyIds;
        this.typeId = typeId;
        this.floor = floor;
        this.proposedSpecialtyIds = proposedSpecialtyIds;
    }

    @action
    public setStatus(status: OfficeStatus): void {
        this.status = status;
    }
}
